import plMessages from '../locales/pl_PL.json';
import merchandisingMessages from '../locales/merchandising';

const PlLang = {
  messages: {
    ...merchandisingMessages,
    ...plMessages,
  },
  locale: 'pl-PL',
};
export default PlLang;
